export const serverErrorHandler = (error: any) => {
  return Object.entries(error.response.data)
    .map(([_, value]) => {
      return `${Array.isArray(value) ? value.join(" ") : value}`;
    })
    .join("\n");
};
